<template>
    <div id="StockInventory">
      <div class="mx-4">
        <q-btn v-if="user?.organization?.onlineOfflineType !== 2" class="offline-btn mt-3 mx-2" 
          :class="[
            { 'pd-btn': currentTab == 'offline', 'inactive-btn': currentTab != 'offline' },
            { 'offline-btn': user?.organization?.onlineOfflineType !== 2, 'offline-btn-2': user?.organization?.onlineOfflineType === 2 }
          ]"
          @click="currentTab = 'offline'" label="Offline Channel">
        </q-btn>
        <q-btn v-if="user?.organization?.onlineOfflineType !== 2" class="online-btn mt-3" :class="currentTab == 'online' ? 'pd-btn': 'inactive-btn'" @click="currentTab = 'online'" label="Online Channel">
        </q-btn>
      </div>
        <!-- <q-separator class="mb-4 mt-3 mx-4"></q-separator> -->
      <PurchaseOffline v-show="currentTab === 'offline'"></PurchaseOffline>
      <PurchaseOnline v-show="currentTab === 'online' && user?.organization?.onlineOfflineType !== 2"></PurchaseOnline>
    </div>
</template>

<script>
import PurchaseOffline from './PurchaseOffline';
import PurchaseOnline from './PurchaseOnline';

export default {
    name: 'Purchase',
    components: {
        PurchaseOffline,
        PurchaseOnline
    },

    data() {
        return {
            currentTab: 'offline',
            user: JSON.parse(localStorage.getItem('user')),
        }
    }
}
</script>

<style scoped>
.q-btn {
  text-transform: none !important;
  font-weight: 600;
  color: #105992
}

.offline-btn {
  border-radius: 8px 0px 0px 8px;
}

.offline-btn-2 {
    border-radius: 8px 8px 8px 8px;
}

.online-btn {
  border-radius: 0px 8px 8px 0px;
  margin-left: -9px;
}

.inactive-btn {
  background-color: #ECEFF1;
}
</style>